import axios from '@/allotment/axios'

export default {
  count: id => axios.post('/station/total/capacity', { id }), //获取电站电量统计
  page: data => axios.post('/station/select/page', data), //获取电站列表
  status: data => axios.post('/station/count/status', data), //获取电站状态
  previewCount: id => axios.get(`/station/detail/count/part/${id}`), //获取电站设备
  previewChart: id => axios.get(`/station/line/chart/${id}`), //获取电站预览图
  previewChartNew: data => axios.post('/station/line/chart', data), //获取电站预览图（新）
  save: data => axios.post('/station/save', data), //保存电站
  basic: id => axios.get(`/station/detail/basic/${id}`), //获取电站基本信息
  info: id => axios.get(`/station/detail/info/${id}`), //获取电站资料
  device: data => axios.post('/station/device/list', data), //获取设备数据
  exit: data => axios.post('/station/device/exit', data), //退出电站
  addDevice: data => axios.post('/station/device/save', data), //添加设备
  guide: id => axios.get(`/station/detail/overview/${id}`), //获取概览数据
  guideChart: data => axios.post('/station/detail/overview/chart', data), //获取概览详情统计图
  guideBarChart: data => axios.post('/station/detail/overview/barChart', data), //获取概览详情统计图
  guideChartDownload: data => axios.post('/station/detail/chart/download', data, { notbody: true, responseType: 'blob', timeout: 10 * 60000 }), //电站概览概况统计图下载
  delete: id => axios.get(`/station/delete/${id}`), //删除电站
  getThr: id => axios.get(`/station/thr/get/${id}`), //获取参数设置数据
  saveThr: data => axios.post('/station/thr/save', data), //保存参数设置数据
  getDeviceTree: id => axios.post('/station/device/tree', { stationId: id }), //获取电站设备树形
  getWeather: id => axios.get(`/station/detail/weather/${id}`), //获取电站天气
  masterOrSlave: data => axios.post('/station/device/save/masterOrSlave', data), //更新设备主从
  sysname: data => axios.post('/station/device/save/sysname', data) //更新系统名称
}
